// extracted by mini-css-extract-plugin
export default {"notification":"_29iB5","notification-wrapper":"_1bFIQ","notificationWrapper":"_1bFIQ","tooltip":"OHOx1"};